/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-form-input">
	<template>
    <style>
      :host {
        background-color: #fff;
        display: block;
        height: 48px;
        padding: 16px 24px;
        position: relative;
        width: 100%;
      }

      @media only screen and (min-width: 1024px) {
        :host {
          height: 60px;
        }
      }

      :host([text-color=light]) {
        background-color: var(--cs-dark-color);
      }

      :host([background-color="none"]) {
        background-color: transparent;
      }

      :host([background-color="dark"]) {
        background-color: var(--cs-dark-color);
      }

      :host([background-color="light"]) {
        background-color: #fff;
      }

      /* disabled variant */
      :host([disabled]) {
        background-color: var(--cs-light-color);
        pointer-events: none;
      }

      :host([disabled][theme="light"]) {
        background-color: var(--cs-dark-color);
      }

      /** * Before */
      :host::before {
        border: solid 2px var(--cs-dark-color);
        border-radius: 3px;
        bottom: 0;
        content: "";
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        transition: border-width 0.1s, bottom 0.1s, left 0.1s, right 0.1s, top 0.1s;
      }

      /* light variant */
      :host([text-color=light])::before {
        border-color: var(--cs-light-color);
      }

      /* hover and current */
      :host(:hover)::before, :host([current])::before {
        border-width: 2px;
        bottom: -3px;
        left: -3px;
        right: -3px;
        top: -3px;
      }

      :host([error])::before {
        border-color: var(--cs-error-color);
      }

      /** * Label */
      .cspl-input__label {
        color: #a3a3a3;
        font-size: 16px;
        margin-bottom: 0;
        margin-top: 0;
        pointer-events: none;
        position: absolute;
        top: 20px;
        transform: translateY(-7px);
        transform-origin: top left;
        transition: transform .25s cubic-bezier(.5, .25, .015, 1);
        width: 100%;
      }

      :host([rtl]) .cspl-input__label {
        transform-origin: top right;
      }

      @media only screen and (min-width: 1024px) {
        .cspl-input__label {
          top: 22px;
        }
      }

      @media only screen and (min-width: 1456px) {
        .cspl-input__label {
          top: 24px;
        }
      }

      /* light variant */
      :host([text-color=light]) .cspl-input__label {
        color: #585858;
      }

      /* current and :not(_empty) */
      :host([current]) .cspl-input__label, :host(:not([_empty])) .cspl-input__label {
        transform: translateY(-13px) scale(.75);
      }

      @media only screen and (min-width: 1456px) {
        :host([current]) .cspl-input__label, :host(:not([_empty])) .cspl-input__label {
          transform: translateY(-15px) scale(.75);
        }
      }

      /** * Iron Input */
      .cspl-input__iron-input {
        width: 100%;
      }

      /** * Input field */
      .cspl-input, .cspl-input__input {
        background-color: transparent;
        border: 0;
        box-shadow: none;
        color: var(--cs-dark-color);
        font-family: var(--cs-theme-primary-font-family);
        font-size: 14px;
        outline: none;
        padding: 0;
        transition: transform .25s cubic-bezier(.5, .25, .015, 1);
        width: 100%;
      }

      /* disabled variant */
      :host([disabled]) .cspl-input__label {
        color: #c2c2c2;
      }

      :host([disabled]) .cspl-input, :host([disabled]) .cspl-input__input {
        opacity: 0.4;
      }

      :host([theme="light"][disabled]) .cspl-input__label {
        color: #585858;
      }

      /* light variant */
      :host([text-color=light]) .cspl-input, :host([text-color=light]) .cspl-input__input {
        color: var(--cs-light-color);
      }

      @media only screen and (min-width: 1456px) {
        .cspl-input, .cspl-input__input {
          font-size: 18px;
        }
      }

      /* current and :not( _empty ) */
      :host([current]) .cspl-input__input, :host(:not([_empty])) .cspl-input__input {
        transform: translateY(5px);
      }

      @media only screen and (min-width: 1456px) {
        :host([current]) .cspl-input__input, :host(:not([_empty])) .cspl-input__input {
          transform: translateY(11px);
        }
      }

      /* invalid variant */
      .cspl-input__input:invalid {
        box-shadow: none;
      }
    </style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
